import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'

export function getGretaAIChatFeedbackPayload({ comment, reason, value }) {
  return {
    value,
    ...(reason ? { reason } : EMPTY_OBJECT),
    ...(comment ? { comment } : EMPTY_OBJECT),
  }
}

export function getGretaAIChatFeedbackWithoutMessage(
  feedbackByMessageId,
  messageId
) {
  return Object.fromEntries(
    Object.entries(feedbackByMessageId).filter(([id]) => id !== messageId)
  )
}

export function getGretaAIChatRefreshedFeedback({
  current,
  messages,
  previousMessages = EMPTY_LIST,
}) {
  const previousMessageById = new Map(
    previousMessages.map(message => [message.id, message])
  )

  return messages.reduce((feedbackByMessageId, message) => {
    if (previousMessageById.get(message.id) === message) {
      return feedbackByMessageId
    }

    return message.feedback
      ? { ...feedbackByMessageId, [message.id]: message.feedback }
      : getGretaAIChatFeedbackWithoutMessage(feedbackByMessageId, message.id)
  }, current)
}
